export class RectangularSvgPathCreator {
  constructor(bound) {
    this.bound = bound;
  }
  createSvgPath() {
    return "M ".concat(this.bound.left, ",").concat(this.bound.top, " h").concat(this.bound.width, " v").concat(this.bound.height, " h-").concat(this.bound.width);
  }
}
export class HexagonSvgPathCreator {
  constructor(cX, cY, width, height) {
    const side = width / 2;
    const halfSide = side / 2;
    const halfHeight = height / 2;
    this.points = [];
    this.points.push({
      x: cX + side,
      y: cY
    });
    this.points.push({
      x: cX + halfSide,
      y: cY - halfHeight
    });
    this.points.push({
      x: cX - halfSide,
      y: cY - halfHeight
    });
    this.points.push({
      x: cX - side,
      y: cY
    });
    this.points.push({
      x: cX - halfSide,
      y: cY + halfHeight
    });
    this.points.push({
      x: cX + halfSide,
      y: cY + halfHeight
    });
  }
  createSvgPath() {
    let svgPath = "M ".concat(this.points[0].x, " ").concat(this.points[0].y, "  ");
    svgPath += "L ".concat(this.points[1].x, " ").concat(this.points[1].y, "  ");
    svgPath += "L ".concat(this.points[2].x, " ").concat(this.points[2].y, "  ");
    svgPath += "L ".concat(this.points[3].x, " ").concat(this.points[3].y, "  ");
    svgPath += "L ".concat(this.points[4].x, " ").concat(this.points[4].y, "  ");
    svgPath += "L ".concat(this.points[5].x, " ").concat(this.points[5].y, "  ");
    svgPath += "Z";
    return svgPath;
  }
}